import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useViewport } from "@core/theme";
import { Button, Flex, Surface } from "@mm/ui";
import { GeneralModalShell } from "@/components/atoms";
import { Loading } from "@/components/molecules";
import { addToCart } from "@/features/Streaming";
import { useNavigate, useSearchParams } from "react-router-dom";
const WaipuMainSection = styled("div") `
  font-size: 18px;
  max-width: 1304px;
  width: 100%;
  margin: 0 auto;

  .waipu-table {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 12;
    margin-bottom: 40px;

    &-header {
      cursor: pointer;
    }

    &--headline {
      display: block;
      font-size: 18px;
      font-weight: 700;
    }

    &--price {
      font-size: 18px;
    }

    &--hint {
      font-size: 12px;
      display: block;
    }

    &--column {
      display: grid;
      grid-column-start: 1;
      grid-column-end: 4;
      grid-template-columns: 1fr 1fr 1fr;

      > div {
        padding: 10px 5px;
      }

      &--mobile-fixed {
        position: fixed;
        bottom: 0;
        background: white;
        width: 100%;
        left: 0;
        z-index: 10;
        box-shadow: -1px -4px 5px 0px rgba(0, 0, 0, 0.25);
      }
    }

    .text-center {
      text-align: center;
    }

    .sm-visible-none {
      display: none;
    }

    .border-bottom {
      border-bottom: 2px solid #cdcaca;

      &--active {
        border-color: red;
      }
    }

    .item-a {
      font-size: 14px;
      grid-column-start: 1;
      grid-column-end: 4;
      text-align: center;
      border-bottom: 0;
    }

    @media (min-width: ${({ theme }) => theme.breakpointsMap.md.min}px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;

      &--headline {
        font-size: 24px;
      }

      &--price {
        font-size: 22px;
      }

      &--productLogo {
        margin: 0 auto 20px;
      }

      &--column {
        display: grid;
        grid-column-start: 1;
        grid-column-end: 5;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        > div {
          padding: 30px 10px;
        }

        &--mobile-fixed {
          position: relative;
          bottom: unset;
          background: white;
          width: unset;
          left: unset;
          z-index: unset;
          box-shadow: none;
        }
      }

      .item-a {
        font-size: 18px;
        grid-column-start: 1;
        grid-column-end: 1;
        text-align: left;
        border-bottom: 2px solid #cdcaca;

        &--no-border {
          border-bottom: 0;
        }
      }

      .sm-visible-none {
        display: block;
      }
    }
  }
`;
const WaipuTariffSection = ({ offers }) => {
    const { lessThan: { md }, } = useViewport();
    const [pageOffers, setPageOffers] = useState(offers);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const outletId = searchParams.get("oid");
    const housingAssociation = searchParams.get("wbg");
    useEffect(() => {
        const getWaipuTableHeaders = document.getElementsByClassName("waipu-table-header");
        for (const item of getWaipuTableHeaders) {
            item.addEventListener("click", () => {
                item.classList.toggle("border-bottom--active");
                const parentElement = item.parentNode;
                if (parentElement) {
                    const siblings = Array.from(parentElement.children).filter(function (child) {
                        return child !== item;
                    });
                    siblings.map((item) => item.classList.remove("border-bottom--active"));
                }
            }, false);
        }
    }, []);
    useEffect(() => {
        function handleScroll() {
            const pageFooter = document.getElementById("waipu-table");
            const waipuTableFooter = document.getElementById("waipu-table-footer");
            if (pageFooter && waipuTableFooter && md) {
                if (pageFooter?.getBoundingClientRect().bottom < 1000) {
                    waipuTableFooter?.classList.remove("waipu-table--column--mobile-fixed");
                }
                if (pageFooter?.getBoundingClientRect().bottom > 1000) {
                    waipuTableFooter?.classList.add("waipu-table--column--mobile-fixed");
                }
            }
        }
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [md]);
    useEffect(() => {
        if (offers) {
            /**
             * In the future we are going to have more than three offers.
             * The user will be able to choose the offers he wants to see in the table.
             */
            setPageOffers(offers.slice(0, 3));
        }
    }, [offers]);
    const handleOrderClick = (offer) => {
        if (offer.offerId && offer.tariff?.id) {
            addToCart({
                url: offer.offerGroupUrl,
                offerId: offer.offerId,
                tariffId: offer.tariff.id,
                data: {
                    ...(outletId && { outletId }),
                    ...(housingAssociation && { housingAssociation }),
                },
            }).then((result) => {
                if (result.success) {
                    navigate("/waipu/checkout/step/1");
                }
            });
        }
    };
    if (!pageOffers)
        return _jsx(Loading, { variant: "home" });
    return (_jsx(Surface, { variant: "wide", children: _jsxs(WaipuMainSection, { children: [_jsx("h1", { children: "Pakete im Vergleich" }), _jsxs("div", { id: "waipu-table", className: "waipu-table", children: [_jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom sm-visible-none" }), pageOffers.map((offer, index) => (_jsxs("div", { className: `text-center border-bottom ${index == 1 ? "border-bottom--active" : ""} waipu-table--cell waipu-table-header`, children: [_jsx("img", { src: `https://storage.googleapis.com/content-ekontor24/mediamarkt/img/campaign/waiputv/${offer.name
                                                .toLowerCase()
                                                .replaceAll(" ", "-")}.png`, width: "110", className: "sm-visible-none waipu-table--productLogo", alt: "" }), _jsx("span", { className: "waipu-table--headline", children: offer.name })] }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "Preis im Monat" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zum Preis", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Preis im Monat" }) }), _jsx("p", { children: "Genie\u00DFe grenzenloses Fernsehvergn\u00FCgen mit waipu.tv und das zu einem attraktiven monatlichen Preis. Dein Abonnement wird bequem und transparent jeden Monat abgebucht, sodass du dich ganz auf deine Lieblingssendungen konzentrieren kannst." })] })] }) }), pageOffers.map((offer) => (_jsxs("div", { className: "text-center border-bottom", children: [_jsx("b", { className: "waipu-table--price", children: offer.tariff?.properties?.tariff_monthly_price }), _jsxs("span", { className: "waipu-table--hint", children: [offer.tariff?.pricingIntervals?.intervals &&
                                                    offer.tariff.pricingIntervals.intervals.length > 1 && (_jsxs(_Fragment, { children: ["1. Monat kostenlos, ab dem", " ", offer.tariff?.pricingIntervals.intervals[1].startMonth, ". Monat ", offer.tariff?.properties?.tariff_monthly_price] })), !(offer.tariff?.pricingIntervals?.intervals &&
                                                    offer.tariff.pricingIntervals.intervals.length > 1) &&
                                                    offer.tariff?.monthlyPriceAddendum && (_jsx(_Fragment, { children: offer.tariff?.monthlyPriceAddendum }))] })] }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsx("b", { children: "1. Monat kostenlos" }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_first_month_free }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsx("b", { children: "Monatlich k\u00FCndbar" }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_cancel_monthly }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "TV-Sender" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zum TV-Sender", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Senderanzahl" }) }), _jsxs("p", { children: ["Tauche ein in die Welt des Fernsehens mit waipu.tv und erhalte Zugang zu allen Top-Sendern, die du liebst. Mit Kan\u00E4len wie Das Erste, ZDF, RTL, ProSieben und vielen mehr, bietet dir waipu.tv das volle Programm f\u00FCr deine Unterhaltung. F\u00FCr eine detaillierte \u00DCbersicht aller verf\u00FCgbaren Sender, \u00F6ffne bitte unser", " ", _jsx("a", { href: `https://storage.googleapis.com/content-ekontor24/mediamarkt/pdf/waipu/waipu_senderliste.pdf`, target: "_blank", rel: "noreferrer", children: "Senderliste-PDF" }), "."] })] })] }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_tv_stations }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsx("b", { children: "Aufl\u00F6sung in HD" }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_hd_resolution }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "Pay-TV" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zu Pay-TV", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Pay-TV-Option" }) }), _jsx("p", { children: "Das Perfect Plus von waipu.tv beinhaltet bereits die Pay-TV Option ohne weitere Zusatzkosten." })] })] }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_pay_tv }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsxs("div", { className: "border-bottom item-a", children: [_jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "waiputhek" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zu waiputhek", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "waiputhek" }) }), _jsx("p", { children: "Erlebe in der waiputhek eine gro\u00DFartige Vielfalt aus allen Genres: Filme, Serien, Comedy, Kinderunterhaltung, Dokus und vieles mehr. Zus\u00E4tzlich findest du hier aktuelle TV-Empfehlungen und erh\u00E4ltst Zugang zu all unseren Mediatheken. Du kannst auf die waiputhek aus jedem waipu.tv-Paket zugreifen." }), _jsx("p", { children: "waipu.tv ist auf dem PC, Smartphone und Tablet sowie waipu.tv 4K Stick, Amazon Fire TV, Apple TV, Google TV, LG TV, Samsung-TV und Roku komfortabel auf jedem Fernseher verf\u00FCgbar." })] })] }), _jsx("span", { className: "waipu-table--hint", children: "Filme, Serien & Shows auf Abruf" })] }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_waiputhek }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "Aufnahmen (in Std.)" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zur Aufnahme Funktion", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Aufnahmen" }) }), _jsx("p", { children: "Mit waipu.tv verpasst du nie wieder deine Lieblingssendung. Nimm Filme und Serien einfach per Knopfdruck auf und speichere sie im Online-Speicher \u2013 ohne deinen Ger\u00E4tespeicher zu belasten. Dank der praktischen Serienaufnahme werden sogar ganze Serien automatisch f\u00FCr dich aufgezeichnet. Bei einigen Sendungen ist die Funktion aus lizenzrechtlichen Gr\u00FCnden nicht oder nur eingeschr\u00E4nkt m\u00F6glich." })] })] }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_recording_hours }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsx("div", { className: "border-bottom item-a", children: _jsxs(Flex, { alignItems: "center", justifyContent: ["center", "center", "center", "flex-start"], children: [_jsx("b", { children: "Parallel fernsehen" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zum parallelen Fernsehen", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Parallel fernsehen" }) }), _jsx("p", { children: "Mit deinem waipu.tv-Paket erlebst du volle Flexibilit\u00E4t beim Fernsehen. Streame je nach Paket auf bis zu 4 Ger\u00E4ten gleichzeitig dein TV-Programm." })] })] }) }), pageOffers.map((offer) => (_jsx("div", { className: "text-center border-bottom", children: offer.tariff?.properties?.tariff_concurrent_streams }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column", children: [_jsxs("div", { className: "item-a item-a--no-border", children: [_jsx("b", { children: "Neustart und Pause" }), "\u00A0", _jsxs(GeneralModalShell, { ariaLabel: "Weitere Informationen zun den Funktionen Neustart und Pause", opener: _jsx("i", { className: "icon-MM_iconfont_Info", "aria-hidden": true }), children: [_jsx("p", { children: _jsx("b", { children: "Neustart und Pause" }) }), _jsx("p", { children: "Neustart und Pause sind bei einigen Sendungen aus lizenzrechtlichen Gr\u00FCnden nicht oder nur eingeschr\u00E4nkt m\u00F6glich." })] })] }), pageOffers.map((offer) => (_jsx("div", { className: "text-center", children: offer.tariff?.properties?.tariff_restart_pause_function }, offer.name)))] }), _jsxs("div", { className: "waipu-table--column waipu-table--column--mobile-fixed", id: "waipu-table-footer", children: [_jsx("div", { className: "sm-visible-none" }), pageOffers.map((offer, index) => (_jsx("div", { className: "text-center", children: _jsx(Button, { onClick: () => handleOrderClick(offer), type: "button", qaName: `offer${index}`, "aria-label": `Jetzt ${offer.name} bestellen`, children: "Jetzt bestellen" }) }, offer.name)))] })] })] }) }));
};
export default WaipuTariffSection;
